module.exports = __webpack_public_path__ + "img/47-scientist.95fb2954.svg";